// 完整版菜单比较多，将 rank 抽离出来，在此方便维护

const home = 0, // 平台规定只有 home 路由的 rank 才能为 0 ，所以后端在返回 rank 的时候需要从非 0 开始
  chatai = 1,
  vueflow = 2,
  ganttastic = 28,
  components = 4,
  able = 5,
  table = 6,
  form = 7,
  list = 8,
  result = 9,
  error = 10,
  frame = 11,
  nested = 12,
  permission = 13,
  system = 14,
  monitor = 15,
  tabs = 16,
  about = 17,
  codemirror = 18,
  markdown = 19,
  editor = 20,
  flowchart = 21,
  formdesign = 22,
  board = 23,
  ppt = 24,
  mind = 25,
  guide = 26,
  menuoverflow = 27,
  myProject = 1,
  myLiveRoom = 2,
  speechLibrary = 3,
  scriptLibrary = 4,
  account = 30,
  aiLive = 3,
  aiVideo = 2,
  qualificationReview = 5,
  talentPhoto = 6,
  materialLibrary = 7,
  aIExpertVideo = 8,
  videoGenerationTask = 9;
export {
  home,
  chatai,
  vueflow,
  myProject,
  speechLibrary,
  scriptLibrary,
  myLiveRoom,
  ganttastic,
  components,
  able,
  table,
  form,
  list,
  result,
  error,
  frame,
  nested,
  permission,
  system,
  monitor,
  tabs,
  about,
  codemirror,
  markdown,
  editor,
  flowchart,
  formdesign,
  board,
  ppt,
  mind,
  guide,
  menuoverflow,
  account,
  aiLive,
  aiVideo,
  qualificationReview,
  talentPhoto,
  materialLibrary,
  aIExpertVideo,
  videoGenerationTask
};
